export default "__VITE_ASSET__f11e7920__"